import request from "../request";

export const getLevelDetail = async (data) =>
    request({
        url: "/v1/FloorLevel/Read",
        method: "PATCH",
        data,
    });
